import { FirebaseFile } from "@/data/providers/files-provider";

export class HomeState {
	public projects: Array<FirebaseFile> = [];

	public isBusy: boolean = false;
}